// Arms of experiment-referral-signup-name, the homepage welcome for a visitor who arrived
// on a colleague's referral link. Three arms, so the flag answers both questions the
// feature raises: does opening the sign-up modal at all help, and does naming the referrer
// add anything on top of opening it.
//
//   OFF     — the homepage as it is today, no modal. The holdout.
//   GENERIC — the modal opens with the standard "Welcome! Let's get started." copy.
//   NAMED   — the modal opens headlined "<referrer> invited you to Diffit!".
//
// A multivariate LaunchDarkly flag serving these three strings. Anything else — the flag
// missing, an unknown variation, a boolean left over from a mis-typed rule — is OFF, so a
// misconfiguration shows the holdout experience rather than an untested one.
export const REFERRAL_WELCOME_ARM = {
  OFF: 'off',
  GENERIC: 'generic',
  NAMED: 'named',
};

const ARMS = new Set(Object.values(REFERRAL_WELCOME_ARM));

export const referralWelcomeArm = (flagValue) =>
  ARMS.has(flagValue) ? flagValue : REFERRAL_WELCOME_ARM.OFF;

// Whether an arm opens the modal at all. The two treatment arms share every condition
// except the copy, so the opener asks this once rather than listing arms twice.
export const armOpensModal = (arm) => arm !== REFERRAL_WELCOME_ARM.OFF;
